//@flow
import * as actionTypes from './actionTypes';
import { phoenixlegacyapi } from '@lesofi/phoenix-sdk-js'
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import { getFormTypeData } from './submitFormData'
import type { Dispatch$Type,ReducerState$Type } from '../genericFlowTypes'
import type { PostKratosForm$Type } from './flowTypes'

const workflowType = 'Kratos'

export const getTaskData=(kratos:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => phoenixlegacyapi.getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.KRATOS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            //console.log(data)
            const formData = transformDataToEditFormData(data,kratos)
            dispatch({
                type: actionTypes.KRATOS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.KRATOS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const formDataSubmissionCompleted = () => {
    return { type: actionTypes.KRATOS_INV_SUBMITTED_COMPLETED };
}

export const formDataSubmission = (jwt:any,taskAcceptedInfoId:number,kratosResultset:any,kratos:ReducerState$Type)=>{
    let payload:PostKratosForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (kratosResultset.isInvalidDoc){
        payload.isInvalidDoc=true
    }else {
        payload.isInvalidDoc=false
        payload.formType = kratosResultset.formType
        payload.formServiceYear = kratosResultset.formServiceYear
        payload.formData = getFormTypeData(kratosResultset)
    }

    if (kratos.reviewQuestions && kratos.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(kratosResultset,kratos.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => phoenixlegacyapi.submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.KRATOS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.KRATOS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.KRATOS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.KRATOS_UPDATE_FORM_ERROR, formError: error }
}

export const refreshCacheValue=(key:any, value:any)=>{
    return { type: actionTypes.REFRESH_KRATOS_CACHE_VALUE, anyKey: key, anyValue: value }
}


// WEBPACK FOOTER //
// ./src/redux/kratos/actions.js